namespace Matrix.Indexation {
    export namespace DimIndexationProfileService {
        export const baseUrl = 'Indexation/DimIndexationProfile';

        export declare function Create(request: Serenity.SaveRequest<DimIndexationProfileRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<DimIndexationProfileRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<DimIndexationProfileRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DimIndexationProfileRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Indexation/DimIndexationProfile/Create",
            Update = "Indexation/DimIndexationProfile/Update",
            Delete = "Indexation/DimIndexationProfile/Delete",
            Retrieve = "Indexation/DimIndexationProfile/Retrieve",
            List = "Indexation/DimIndexationProfile/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>DimIndexationProfileService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
